import type { SequenceModuleConfig } from "@/ts/module";

export const sequenceModule: SequenceModuleConfig = {
	nav: ["AuctionController", "GPTRefresh"],
	carousel: ["SlotDiscovery", "AuctionController", "GPT"],
};
